let config = {};
export default class Config{
    static initConfig(_config){
        config = _config;
    }
    static addConfig(key,value){
        return config[key] = value;
    }
    static getConfig(key){
        return config[key];
    }
}
